module.exports = {
      id: "twitter-circular-plain-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite-b35941cc40d7fc0f39708cadaf87d26a.svg#twitter-circular-plain",
      toString: function () {
        return this.url;
      }
    }